import React, { useEffect, useState } from "react";
import { IoMdSend } from "react-icons/io";
import LoadingPage from "../Loading/loading";
import {
  banUser,
  getUsers,
  doneUser,
  searchUsers,
  unbanUser,
  updateEarning,
  downloadExcel,
} from "../../api/brokers";
import { changeAdmin, getAdmins } from "../../api/admins";
import { Cookies } from "react-cookie";

const BrokerComponent = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [id, setId] = useState("");
  const [newEarning, setNewEarning] = useState(0);
  const [users, setUsers] = useState(null);
  const [admins, setAdmins] = useState(null);
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [totalPages, setPages] = useState([]);
  const [totalUser, setTotalUser] = useState(0);
  const [currentPage, setCurrentPage] = useState(cookie.get("page") || 1);

  const fetchUsers = () => {
    getUsers(
      currentPage,
      "Brokers",
      props.page === "New Brokers",
      props.page === "Banned Brokers",
    ).then((result) => {
      setUsers(result.data.response);
      setTotalUser(result.data.total);
      setPages(result.data.pages);
    });
  };

  useEffect(() => {
    setUsers(null);
    getAdmins().then((result) => {
      setAdmins(result.data.admins);
    });
    if (!searchTerm || searchTerm === "") {
      fetchUsers();
    }
  }, [currentPage]);

  const handleSearch = () => {
    setCurrentPage(1);
    setUsers(null);
    if (!searchTerm || searchTerm === "") {
      fetchUsers();
    } else {
      searchUsers(
        "Broker",
        searchTerm,
        1,
        props.page === "New Brokers",
        props.page === "Banned Brokers",
      ).then((result) => {
        setUsers(result.data.response);
        setTotalUser(result.data.total);
        setPages(result.data.pages);
      });
    }
  };

  const ban = (id) => {
    banUser(id).then((result) => {
      setUsers(users.filter((user) => user._id !== id));
    });
  };

  const unban = (id) => {
    unbanUser(id).then((result) => {
      setUsers(users.filter((user) => user._id !== id));
    });
  };

  const done = (id) => {
    doneUser(id).then((result) => {
      setUsers(users.filter((user) => user._id !== id));
    });
  };

  const earning = (id, newEarnings) => {
    updateEarning(id, parseInt(newEarnings)).then((result) => {
      setUsers(
        users.map((user) =>
          user._id === id ? { ...user, earnings: newEarnings } : user,
        ),
      );
      setId("");
      setNewEarning(0);
    });
  };

  const change = (oldAdmin, newAdmin, userId) => {
    changeAdmin(oldAdmin, newAdmin, userId).then((result) => {
      setUsers(
        users.map((user) =>
          user._id === userId ? { ...user, admin_id: newAdmin } : user,
        ),
      );
    });
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      cookie.set("page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (totalPages <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, totalPages - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < totalPages - 1) {
          pages.push("...");
        }
        pages.push(totalPages);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  return (
    <>
      {users === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            <form
              onSubmit={(e) => {
                e.preventDefault(); // Prevent page reload
                handleSearch();
              }}
            >
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Name or Phone number"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <button
                  type="button"
                  onClick={() => {
                    handleSearch();
                  }}
                  className="password-toggle"
                  aria-label="Show password"
                >
                  <IoMdSend />
                </button>
              </div>
            </form>
          </div>

          <div>Number of Brokers is {totalUser}</div>

          {isSuper && props.page === "Brokers" && (
            <button onClick={downloadExcel}>Download</button>
          )}

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {renderPageNumbers()}
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="paginationButton"
            >
              Next
            </button>
          </div>

          <div className="card-cards">
            {users?.length === 0 ? (
              <div>Not found</div>
            ) : (
              <>
                {users?.map((user) => (
                  <div
                    key={user._id}
                    className={`card-card ${user.ban ? "banned" : ""}`}
                  >
                    <div className="card-info">
                      <div>
                        <p className="line">
                          <span className="label">Name:</span> {user.name}
                        </p>
                        <p className="line">
                          <span className="label">Phone:</span> {user.phone}
                        </p>
                        <p className="line">
                          <span className="label">Destination:</span>{" "}
                          {user.area}
                        </p>
                        <p className="line">
                          <span className="label">Work at:</span> {user.work_at}
                        </p>
                        {user.user_invitation && (
                          <p className="line">
                            <span className="label">Invited name by:</span>{" "}
                            {user.user_invitation.name}
                          </p>
                        )}
                        {user.user_invitation && (
                          <p className="line">
                            <span className="label">Invited phone by:</span>{" "}
                            {user.user_invitation.phone}
                          </p>
                        )}
                        {isSuper && (
                          <>
                            {admins !== null && (
                              <p className="line">
                                <span className="label">Admin:</span>{" "}
                                <select
                                  className="form-select form-control form-select-lg border border-dark"
                                  aria-label=".form-select-lg example"
                                  name="type2"
                                  value={user.admin_id}
                                  onChange={(e) => {
                                    change(
                                      user.admin_id,
                                      e.target.value,
                                      user._id,
                                    );
                                  }}
                                >
                                  <option value="">No Admin</option>
                                  {admins.map((item, index) => (
                                    <option key={index} value={item._id}>
                                      {item.admin_code}
                                    </option>
                                  ))}
                                </select>
                              </p>
                            )}
                          </>
                        )}
                        <p className="line">
                          <span className="label">Years experience:</span>{" "}
                          {user.years_experience}{" "}
                          <span className="label">Years</span>{" "}
                        </p>
                        <p className="line">
                          <span className="label">Earning:</span>{" "}
                          {user.earnings} <span className="label">EGP</span>
                        </p>
                        <p className="line">
                          <span className="label">Join date:</span>{" "}
                          {user.createdAt.split("T")[0]}
                        </p>
                        <p className="line">
                          <span className="label">User type:</span>{" "}
                          {user.user_type === "Broker"
                            ? user.user_type
                            : "Broker and Franchise"}
                        </p>
                        {user._id === id && (
                          <div>
                            <div
                              className="form-group"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <input
                                type="number"
                                id="newEarnig"
                                name="newEarnig"
                                onChange={(e) => setNewEarning(e.target.value)}
                                placeholder="Enter earning"
                              />
                              <IoMdSend
                                style={{
                                  paddingLeft: "10px",
                                  color: "#3498db",
                                  fontSize: "40px",
                                }}
                                onClick={() => {
                                  earning(
                                    user._id,
                                    parseInt(user.earnings) +
                                      parseInt(newEarning),
                                  );
                                }}
                              />
                            </div>
                            <p className="line">
                              <span className="label">New earning:</span>{" "}
                              {parseInt(user.earnings) + parseInt(newEarning)}{" "}
                              <span className="label">EGP</span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {props.page === "New Brokers" && (
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            done(user._id);
                          }}
                          className="action-btn accept-btn"
                        >
                          Done
                        </button>
                      </div>
                    )}

                    {props.page === "Banned Brokers" && (
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            unban(user._id);
                          }}
                          className="action-btn ban-btn"
                        >
                          Unban
                        </button>
                      </div>
                    )}

                    {props.page === "Brokers" && (
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            if (user.ban) {
                              unban(user._id);
                            } else {
                              ban(user._id);
                            }
                          }}
                          className={`action-btn ban-btn`}
                        >
                          Ban
                        </button>
                        {isSuper && (
                          <button
                            onClick={() => {
                              if (id !== user._id) {
                                setId(user._id);
                              } else {
                                setId("");
                              }
                              setNewEarning(0);
                            }}
                            className="action-btn accept-btn"
                          >
                            Add Earning
                          </button>
                        )}
                      </div>
                    )}

                    {/*{isSuper && <>{props.page === "Removed brokers" || props.page === "Removed franchises" ? (<div className="card-actions">
                            <button
                                onClick={() => { unremove(user._id) }}
                                className="action-btn accept-btn"
                            >
                                Unremove
                            </button>
                        </div>) : (<div className="card-actions">
                            <button
                                onClick={() => {
                                    if (user.ban) {
                                        unban(user._id)
                                    } else {
                                        ban(user._id)
                                    }
                                }}
                                className={`action-btn ban-btn`}
                            >
                                {user.ban ? "Unban" : "Ban"}
                            </button>
                            <button
                                onClick={() => remove(user._id)}
                                className="action-btn remove-btn"
                            >
                                Remove
                            </button>
                            <button
                                onClick={() => {
                                    if (id !== user._id) {
                                        setId(user._id)
                                    } else {
                                        setId('')
                                    }
                                    setNewEarning(0)
                                }}
                                className="action-btn accept-btn"
                            >
                                Add Earning
                            </button>
                        </div>)}</>}*/}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BrokerComponent;
